import { produce } from 'immer'
import { ReceiptAttachmentResponse } from 'src/models/receiptAttachment.models'
import {
  GET_EXPENSE_SUCCESS,
  GetExpenseActions,
  PATCH_EXPENSE_SUCCESS,
  PatchExpenseActions,
  POST_CREATE_EXPENSE_SUCCESS,
  PostCreateExpenseActions,
} from 'src/redux/actions/data/expenses.actions'
import {
  POST_ERP_RECEIPT_ATTACHMENTS_FAILURE,
  POST_ERP_RECEIPT_ATTACHMENTS_INIT,
  POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS,
  PostERPReceiptAttachmentsActions,
  UPLOAD_ATTACHMENT_SUCCESS,
  UploadAttachmentSuccessAction,
} from 'src/redux/actions/data/receiptAttachments.actions'
import {
  GET_TRANSACTION_SUCCESS,
  GetTransactionSuccessAction,
} from 'src/redux/actions/data/transactions.actions'
import {
  GET_VIRTUAL_CARD_SUCCESS,
  GetVirtualCardActions,
  GetVirtualCardsSuccessAction,
  POST_VIRTUAL_CARD_SUCCESS,
  PostVirtualCardSuccessAction,
  PUT_VIRTUAL_CARD_CANCEL_SUCCESS,
  PUT_VIRTUAL_CARD_SUCCESS,
  PutVirtualCardCancelSuccessAction,
  PutVirtualCardSuccessAction,
} from 'src/redux/actions/data/virtualCards.actions'

export interface ReceiptAttachmentsState {
  listResponses: Record<string, ReceiptAttachmentResponse>
  pushingAttachmentsToERP: boolean
}

export const initialState: ReceiptAttachmentsState = {
  listResponses: {},
  pushingAttachmentsToERP: false,
}

export type Actions =
  | UploadAttachmentSuccessAction
  | GetVirtualCardActions
  | PostVirtualCardSuccessAction
  | PutVirtualCardSuccessAction
  | PutVirtualCardCancelSuccessAction
  | GetTransactionSuccessAction
  | GetVirtualCardsSuccessAction
  | PostCreateExpenseActions
  | PatchExpenseActions
  | GetExpenseActions
  | PostERPReceiptAttachmentsActions

const ReceiptAttachmentsReducer = (
  state: ReceiptAttachmentsState = initialState,
  action: Actions,
): ReceiptAttachmentsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case UPLOAD_ATTACHMENT_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.id]: action.payload,
        }
        return draft
      }

      case GET_VIRTUAL_CARD_SUCCESS:
      case PUT_VIRTUAL_CARD_CANCEL_SUCCESS:
      case PUT_VIRTUAL_CARD_SUCCESS:
      case POST_VIRTUAL_CARD_SUCCESS: {
        draft.listResponses = (
          action.payload.virtualCard.receiptAttachments || []
        ).reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        if (
          action.payload.virtualCard.pending?.receiptAttachments !== undefined
        ) {
          draft.listResponses =
            action.payload.virtualCard.pending.receiptAttachments.reduce(
              (acc, curr) => ({
                ...acc,
                [curr.id]: curr,
              }),
              draft.listResponses,
            )
        }
        return draft
      }

      case GET_TRANSACTION_SUCCESS: {
        draft.listResponses = action.payload.receiptAttachments.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case PATCH_EXPENSE_SUCCESS:
      case GET_EXPENSE_SUCCESS: {
        if (action.payload.receiptAttachments !== undefined) {
          draft.listResponses = action.payload.receiptAttachments.reduce(
            (acc, curr) => ({
              ...acc,
              [curr.id]: curr,
            }),
            draft.listResponses,
          )
        }
        return draft
      }

      case POST_CREATE_EXPENSE_SUCCESS: {
        draft.listResponses = (action.payload.receiptAttachments || []).reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }

      case POST_ERP_RECEIPT_ATTACHMENTS_INIT: {
        draft.pushingAttachmentsToERP = true
        return draft
      }
      case POST_ERP_RECEIPT_ATTACHMENTS_SUCCESS: {
        draft.pushingAttachmentsToERP = false
        return draft
      }
      case POST_ERP_RECEIPT_ATTACHMENTS_FAILURE: {
        draft.pushingAttachmentsToERP = false
        return draft
      }
    }
  })
}

export default ReceiptAttachmentsReducer
